import { render, staticRenderFns } from "./TemporaryOffline.vue?vue&type=template&id=21920a26&"
import script from "./TemporaryOffline.vue?vue&type=script&lang=js&"
export * from "./TemporaryOffline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports